/** @jsx h */
import { FunctionalComponent, h } from 'preact';
import { IContentBlockModel } from '../../../../models/ContentBlock';
import { IMenuItemModel } from '../../../../models/Menu';
import { Container } from './footerContentBlockStyled';

export interface IFooterContentBlockProps {
  item: IMenuItemModel;
}

const FooterContentBlock: FunctionalComponent<IFooterContentBlockProps> = ({ item }) => {
  const { text } = item as IContentBlockModel;

  return <Container>{text.getContentValue()}</Container>;
};

export default FooterContentBlock;
